import { JsonObject, JsonProperty } from 'json2typescript';
import { ChatTopicsResponseInterface } from '../interfaces/chat-topics-response.interface';
import { MessagesResponseModel } from './messages-response.model';

@JsonObject('ChatTopicsResponseModel')
export class ChatTopicsResponseModel implements ChatTopicsResponseInterface {
  ChatCategoryId?: string;
  ClientId?: string;
  Color?: string;
  Domain?: string;
  Language?: string;
  Messages?: MessagesResponseModel[];
  Owner?: string;
  Subject?: string;
  TopicDate?: string;
  TopicId?: string;
  UserId?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
